import React from 'react';

const LectureSurveyResultAnswer = ({ answer }) => {
    return (
        <li className={`${answer.isSelected ? 'selected' : ''} ${answer.correct ? 'correct' : 'wrong'} ${!answer.isCorrectAnswer ? 'mistake' : ''}`}>{answer.title}</li>
    );
}

export default LectureSurveyResultAnswer;